import type { ResponseInterceptor } from "../interface/interceptorInterface";
import type { AxiosError, AxiosResponse } from "axios";
import { ToastService } from "../services/toastService";
import router from "../routes";
import { appContainer } from "../container";

export const ResponseErrorInterceptor: ResponseInterceptor = [
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    const toastService = appContainer.resolve(ToastService);
    if (error.response?.status === 500) {
      toastService.error("Something went wrong.");
    }

    if (error.response?.status === 404) {
      router.push({ name: "NotFound" });
    }

    throw error;
  },
];
